import { ModelPrepareProgress } from './types';

export function formatModelProgress(progress?: ModelPrepareProgress | null): string {
    if (!progress) return '-';
    const total = progress.total_bytes ?? 0;
    const amount =
        total > 0
            ? `${Math.min(100, Math.floor((progress.downloaded_bytes * 100) / total))}%`
            : `${progress.downloaded_bytes}B`;
    return `${progress.name} ${progress.phase} ${amount}`;
}

export function formatTerminationMessage(message?: string | null): string {
    if (!message) return '-';
    const oneLine = message.replace(/\s+/g, ' ').trim();
    return oneLine.length <= 80 ? oneLine : `${oneLine.slice(0, 77)}...`;
}
